import { Swiper } from './swiper-dK1UiadY.js';
import { N as Navigation } from './navigation-B1i44Ey9.js';
import { P as Pagination } from './pagination-BK2B-KDe.js';
import { A as A11y } from './a11y-DLppOU3x.js';
import './utils-Djv5ZeLF.js';

class FeaturedProducts extends HTMLElement {
  #swiper = this.querySelector('.swiper');
  #pagination = this.querySelector('.swiper-pagination');
  #nextButton = this.querySelector('.swiper-button-next');
  #prevButton = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.#swiper, {
      modules: [A11y, Pagination, Navigation],
      slidesPerView: 1.33,
      spaceBetween: 16,
      pagination: {
        el: this.#pagination,
        type: 'progressbar',
      },
      breakpoints: {
        640: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 16,
          navigation: {
            nextEl: this.#nextButton,
            prevEl: this.#prevButton,
          },
        },
      },
    });
  }
}

customElements.define('featured-products', FeaturedProducts);
